import React from 'react';
import useInView from '../../hooks/useInView';
import './Problems.css';

const PersonIcon = ({ highlighted }) => (
  <svg
    className={`problems-icon${highlighted ? ' problems-icon--highlighted' : ''}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="32" cy="20" r="12" />
    <path d="M8 56c0-13.255 10.745-24 24-24s24 10.745 24 24H8z" />
  </svg>
);

const Problems = () => {
  const { ref, inView } = useInView({ threshold: 0.3 });

  return (
    <section
      ref={ref}
      className={`problems-section${inView ? ' problems-section--visible' : ''}`}
    >
      <div className="problems-eyebrow-bar">
        <span className="problems-eyebrow">The Problem</span>
      </div>

      <div className="problems-container">
        <div className="problems-layout">
          <div className="problems-icons-col">
            <div className="problems-icons-row">
              {[0, 1, 2, 3].map((i) => (
                <PersonIcon key={i} highlighted={i === 0} />
              ))}
            </div>
          </div>

          <div className="problems-text-col">
            <div className="problems-stat problems-stat--0">
              <p className="problems-stat-text">
                <span className="problems-stat-highlight problems-stat-highlight--primary">
                  1 in 4 renters
                </span>{' '}
                lose their security deposit entirely.
              </p>
            </div>

            <div className="problems-stat problems-stat--1">
              <p className="problems-stat-text">
                <span className="problems-stat-highlight problems-stat-highlight--secondary">
                  35% of those renters
                </span>{' '}
                never received a proper explanation from their landlord.
              </p>
            </div>
          </div>
        </div>

        <div className="problems-stat problems-stat--2 problems-stat--centered">
          <p className="problems-stat-text-big">
            An estimated{' '}
            <span className="problems-stat-highlight problems-stat-highlight--primary">
              $12B
            </span>{' '}
            lost in security deposits across the U.S.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problems;
